<template>
    <div>
        <h3 class="grey-color mb-3 main_text font-weight-bold">Контракты 44-ФЗ</h3>

        <b-overlay :show="isLoading" opacity="0.6" rounded spinner-variant="primary" style="min-height: 100px">
            <b-row class="mb-2 cabinet_filter">
                <filter-new-multiple-select v-model="filter.status" :options="statuses" label="Статус закупки" label-class="grey-color" lg="6" md="6" placeholder="Выберите статус" />
                <filter-new-text v-model="filter.regNumber" label="Рег.номер закупки" md="6" placeholder="Введите рег.номер закупки" />
                <filter-new-multiple-select v-model="filter.deliverableGroups" :options="$globalDictionaries.deliverableGroups" label="Предмет закупки" label-class="grey-color" lg="6" md="6" placeholder="Выберите предметы закупки" />
                <filter-new-multiple-select v-model="filter.orderType" :options="$globalDictionaries.orderTypes" label="Тип закупки" label-class="grey-color" label-field="title" lg="6" md="6" placeholder="Выберите типы закупки" />
                <filter-new-text v-model="filter.customer" label="Заказчик" md="6" placeholder="Введите название или ИНН организации заказчика" />
                <filter-new-text v-model="filter.supplier" label="Поставщик" md="6" placeholder="Введите название или ИНН организации поставщика" />

                <filter-new-radio v-model="filter.type" :options="contractTypes" label="Вид закупки" lg="4" md="4" />
                <b-col class="mt-3 my-2 text-right" lg="8" md="8">
                    <b-btn class="text-uppercase ml-2" style="height: 32px; line-height: 15px" variant="custom-green" @click.prevent="getContracts(true)">НАЙТИ</b-btn>
                    <b-btn class="text-uppercase ml-2" style="height: 32px; line-height: 15px" variant="custom-outline-secondary" @click.prevent="cleanFilters">СБРОС</b-btn>
                    <cabinet-fl44-contracts-export-button class="ml-2 d-inline-block" />
                </b-col>
            </b-row>

            <b-pagination v-if="contracts && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-2 py-0" />

            <component v-for="contract in contracts" :key="`${contract.type}_${contract.id}`" :is="findComponent(contract)" :contract="contract" @refresh="getContracts" />
            <empty-request v-if="!contracts.length && !isLoading"></empty-request>

            <b-pagination v-if="contracts && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-2 py-0" @input="getContracts()" />
        </b-overlay>
    </div>
</template>

<script>
import CabinetFl44ContractsExportButton from '@/components/cabinet/fl44/cabinet-fl44-contracts-export-button.vue';
import FilterNewMultipleSelect from '@/components/common/filter-components/filter-new-multiple-select.vue';
import FilterNewText from '@/components/common/filter-components/filter-new-text.vue';
import FilterNewRadio from '@/components/common/filter-components/filter-new-radio.vue';
import CabinetFl44ExternalPurchaseCard from '@/components/cabinet/fl44/cards/cabinet-fl44-external-purchase-card.vue';
import CabinetFl44PurchaseContractCard from '@/components/cabinet/fl44/cards/cabinet-fl44-purchase-contract-card.vue';
import CabinetFl44UnknownVolumePurchaseContractCard from '@/components/cabinet/fl44/cards/cabinet-fl44-unknown-volume-purchase-contract-card.vue';

const emptyFilter = {
    status: [],
    deliverableGroups: [],
    regNumber: '',
    customer: '',
    supplier: '',
    orderType: [],
    type: ''
};
const filterStatuses = [
    { name: 'Черновик', id: 'draft', for: ['fl44_external'] },
    { name: 'Подведены итоги', id: 'summarized', for: ['fl44'] },
    { name: 'Договор заключен', id: 'contract:active', for: ['fl44', 'fl44_external'] },
    { name: 'Договор исполнен', id: 'contract:fulfilled', for: ['fl44', 'fl44_external'] },
    { name: 'Договор не исполнен', id: 'contract:unfulfilled', for: ['fl44', 'fl44_external'] },
    { name: 'Договор расторгнут', id: 'contract:terminated', for: ['fl44', 'fl44_external'] },
    { name: 'Договор не заключен', id: 'contract:failed', for: ['fl44'] },
    { name: 'Контроль УО', id: 'control', for: ['fl44'] },
    { name: 'Договор заблокирован', id: 'contract:blocked', for: ['fl44', 'fl44_external'] }
];
export default {
    name: 'cabinet-fl44-contracts-list',
    metaInfo: {
        title: 'Закупки 44-ФЗ. Контракты'
    },
    components: {
        CabinetFl44ContractsExportButton,
        FilterNewRadio,
        FilterNewText,
        FilterNewMultipleSelect
    },
    data() {
        return {
            contractTypes: [
                { text: 'Все', value: '' },
                { text: 'В ИС', value: 'fl44' },
                { text: 'Вне ИС', value: 'fl44_external' }
            ],
            contracts: [],
            isLoading: false,
            limit: 10,
            count: 0,
            currentPage: 1,
            number: '',
            id: null,
            showDeleteModal: false,
            showPublishModal: false,
            showCancelModal: false,
            filter: {
                ...emptyFilter
            },
            meta: {
                current_page: 1,
                total: 0,
                per_page: 10
            }
        };
    },
    async mounted() {
        await this.getContracts();
        this.$scrollToTop();
    },
    methods: {
        getFilters(page = true) {
            const filterValues = [];
            for (const [key, value] of Object.entries(this.filter)) {
                if (value) {
                    filterValues[key] = value;
                }
            }
            return {
                ...filterValues,
                page: page ? this.meta.current_page : 1
            };
        },
        async getContracts(page = true) {
            try {
                this.isLoading = true;
                const contractsData = await this.$api.personal.fl44.getContractsList(this.getFilters(page));
                this.contracts = contractsData.data;
                this.meta = contractsData.meta;
            } finally {
                this.isLoading = false;
            }
        },
        async cleanFilters() {
            this.filter = { ...emptyFilter };
            await this.getContracts();
        },
        findComponent(contract) {
            switch (contract.type) {
                case 'fl44_external':
                    return CabinetFl44ExternalPurchaseCard;
                case 'fl44_unknown_volume':
                    return CabinetFl44UnknownVolumePurchaseContractCard;
                default:
                    return CabinetFl44PurchaseContractCard;
            }
        }
    },
    computed: {
        statuses() {
            return this.filter.type ? filterStatuses.filter((item) => item.for.includes(this.filter.type)) : filterStatuses;
        }
    }
};
</script>

<style scoped>
.nav-link,
.nav-item,
.nav-menu {
    padding: 0 !important;
    margin-bottom: -0.04rem !important;
}

.nav-item .nav-link {
    color: #666;
}

.nav-item .nav-link:hover {
    color: #444;
}

.nav-menu {
    font-family: unset;
    font-weight: unset;
    font-size: 14px;
    color: #666666;
}

.nav-menu :hover {
    color: #555555;
}

.nav-link.disabled {
    color: #26b89a !important;
    border-bottom: 2px solid #26b89a;
    font-weight: 600;
}

input::-webkit-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input {
    border-color: rgba(149, 155, 164, 0.2);
}
</style>
